import React from 'react'
import { prepareCommunityMessageContent } from '../utils/communityMessageContent'
import { renderCommunityCustomEmojiTokensInHtml } from '../utils/communityCustomEmojiHtml'
import {
  renderCommunityMentionsInHtml,
  type CommunityMentionUsersById,
} from '../utils/communityMentionsHtml'

type Props = {
  text: string
  mentionUsersById?: CommunityMentionUsersById
}

export function CommunityMessageText({ text, mentionUsersById }: Props) {
  const prepared = React.useMemo(
    () => prepareCommunityMessageContent(String(text || '')),
    [text],
  )
  if (!prepared.text) return null

  const html = React.useMemo(
    () =>
      renderCommunityCustomEmojiTokensInHtml(
        renderCommunityMentionsInHtml(prepared.html, mentionUsersById),
      ),
    [mentionUsersById, prepared.html],
  )

    return (
      <div
        className={[
          'prose prose-invert prose-sm max-w-none break-words',
          'prose-p:my-0 prose-ul:my-0 prose-ol:my-0 prose-li:my-0',
          'post-content',
        ].join(' ')}
        dangerouslySetInnerHTML={{ __html: html }}
      />
    )
  }
